/* eslint-disable */
import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { Autocomplete } from '@material-ui/lab';
import { Box, Button, Container, Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import useApp from '../../hooks/useApp';
import filterStyles from '../filterStyles';

const Filter = ({ filtersParams, setFiltersParams }) => {
  const [filters, setFilters] = useState({
    date_start: DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: DateTime.now().toISODate(),
    partners: [],
    brokers: [],
    client: '',
  });

  const classes = filterStyles();

  const { partners, brokers } = useApp();

  const handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleAutoCompleteChange = (e, value, inputName) => {
    e.preventDefault();

    const values = [];

    if (value) {
      value?.map((item) => {
        values.push(item?.id);
      });
    }

    if (values) {
      setFilters({
        ...filters,
        [inputName]: values,
      });
    }
  };

  const handleFilter = () => {
    setFiltersParams(filters);
  };

  return (
    <Box className={classes.boxFilter}>
      <Grid container spacing={2} alignItems="center">
        <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
          <Grid container item spacing={2} alignItems="flex-end">
            <Grid
              item
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                color: 'GrayText',
              }}>
              <Typography>Data de captura inicial: </Typography>
              <TextField
                type="date"
                name="date_start"
                placeholder="Data Inicial"
                className={classes.inputDate}
                value={filters?.date_start}
                onChange={handleChange}
              />
            </Grid>

            <Grid
              item
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                color: 'GrayText',
              }}>
              <Typography>Data de captura final: </Typography>
              <TextField
                type="date"
                name="date_end"
                placeholder="Data Final"
                className={classes.inputDate}
                onChange={handleChange}
                value={filters?.date_end}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Autocomplete
                multiple
                fullWidth
                name="partners"
                options={partners ? partners : []}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => handleAutoCompleteChange(e, value, 'partners')}
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Empresas" />}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Autocomplete
                multiple
                options={brokers || []}
                fullWidth
                onChange={(e, value) => handleAutoCompleteChange(e, value, 'brokers')}
                getOptionLabel={(option) => option?.name}
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Corretor" />}
              />
            </Grid>

            <Grid item>
              <TextField
                fullWidth
                className={classes.inputSelect}
                variant="standard"
                placeholder="Cliente"
                value={filters.client}
                name="client"
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <Button fullWidth className={classes.button} onClick={handleFilter}>
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filter;
